import { useTranslation } from "react-i18next";
import ListGroup from "./controls/ListGroup";
import ListGroupObjectItem from "./controls/ListGroupObjectItem";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import TextValue from "./controls/TextValue";
import BooleanValue from "./controls/BooleanValue";
import LongTextValue from "./controls/LongTextValue";
import ListValue from "./controls/ListValue";
import { crearEtiquetaTecnologia } from "../utils/data";

export function PlantaTratamientoList({ value, select, remove, disabled }) {
  const { t } = useTranslation();
  return (
    <ListGroup>
      {value.map((item, index) => (
        <ListGroupObjectItem
          key={item.orden}
          index={index}
          value={item}
          indexLabel={t("plantaTratamiento.orden")}
          editable
          onEdit={(event) => {
            event.preventDefault();
            select(index);
            document.getElementById("plantasTratamiento").scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }}
          deletable
          onDelete={(event) => {
            event.preventDefault();
            remove(index);
          }}
          disabled={disabled}
        >
          {({ value }) => (
            <Grid>
              <Row>
                <Col>
                  <TextValue
                    label={t("plantaTratamiento.nombre")}
                    value={value.nombre}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <BooleanValue
                    label={t("plantaTratamiento.conManualOperacion")}
                    value={value.conManualOperacion}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <BooleanValue
                    label={t("plantaTratamiento.conPlanMantenimiento")}
                    value={value.conPlanMantenimiento}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <LongTextValue
                    label={t("plantaTratamiento.descripcion")}
                    value={value.descripcion}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <ListValue
                    label={t("plantaTratamiento.tecnologias")}
                    value={value.tecnologias}
                    ordered
                    labelAttr={crearEtiquetaTecnologia}
                  />
                </Col>
              </Row>
            </Grid>
          )}
        </ListGroupObjectItem>
      ))}
    </ListGroup>
  );
}
